import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { IoCloseOutline } from "react-icons/io5";
import EditableText from "./conedit";

export default function TicketDetails({ OnClose, seatNumber, chatData }) {
  const { user } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(OnClose, 300);
  };

  function formatDateTime(dateStr, timeStr) {
    const dateTime = new Date(`${dateStr}T${timeStr}`);

    const weekday = dateTime.toLocaleString("en-US", { weekday: "short" });
    const month = dateTime.toLocaleString("en-US", { month: "short" });
    const day = dateTime.getDate();
    const time = dateTime.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${weekday}, ${month} ${day}, ${time}`;
  }

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ height: "100%" }}
    >
      <div>
        {/* HEADER & TABS */}
        <div className="mb-4" style={{ backgroundColor: "rgb(22, 19, 22)" }}>
          <div className="flex items-center justify-between w-full pt-2 pb-2 pl-4 pr-4">
            <div className="flex justify-start">
              <button className=" text-gray-200" onClick={handleClose}>
                <IoCloseOutline size={33} />
              </button>
            </div>
            <div className="mx-auto">
              <div className="flex items-center justify-center gap-1">
                <p className="text-md font-medium text-gray-200">
                  Ticket details
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-y-scroll h-[calc(100vh-80px)]">
          <div className="px-4 border-b border-gray-400 pb-2">
            <p className="font-semibold mb-1">Seat Location</p>
            <p>
              {chatData?.seat_no !== "0"
                ? `SEC ${chatData?.section} / ROW ${chatData?.row} / SEAT ${seatNumber}`
                : chatData?.seat_no === "0" && user?.ga_design !== "D2"
                ? `${chatData?.section} General Admission`
                : `SEC ${chatData?.section} / ROW ${chatData?.row} / SEAT - `}
            </p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">{chatData?.event_name}</p>
            <p className="text-gray-600">
              {formatDateTime(chatData.event_date, chatData.event_time)}
            </p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">Entry Info</p>
            <p className="text-gray-600">{chatData.entry_info}</p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">Ticket Info</p>
            <p className="text-gray-600 ">{chatData?.event_name}</p>
            <p className="text-gray-600 mt-1">{chatData?.event_venue}</p>
            <p className="text-gray-600 mt-1">NO PRO CAMS VID/AUD REC</p>
            <p className="text-gray-600 mt-1">
              {formatDateTime(chatData.event_date, chatData.event_time)}
            </p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">{chatData?.event_venue}</p>
            <p className="text-gray-600">
              {chatData?.event_city}, {chatData?.event_state},{" "}
              {chatData?.event_country}
            </p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">Order Number</p>
            <p className="text-gray-600">{chatData.order_num}</p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">Ticket Type</p>
            <p className="text-gray-600">{chatData.ticket_type}</p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">Purchase Date</p>
            <p className="text-gray-600">
              {chatData.purchase_date}, {chatData.purchase_time}
            </p>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">Ticket Price</p>
            <div className="text-gray-600 flex justify-between">
              <p>{chatData?.ticket_type}</p>
              <p>
                {user?.currency}
                {chatData?.ticket_price}
              </p>
            </div>
            <div className="text-gray-600 flex justify-between">
              <p>Fee</p>
              <p>
                {user?.currency}
                <EditableText id="para1" defaultText="0" />
              </p>
            </div>
            <div className="text-gray-600 flex justify-between">
              <p>Grand Total</p>
              <p>
                {user?.currency}
                <EditableText id="para2" defaultText="0" />
              </p>
            </div>
          </div>

          <div className="px-4 border-b border-gray-400 py-4">
            <p className="font-semibold mb-1">Terms & Conditions</p>
            <p className="text-gray-600">
              Please take care of your ticket, as it cannot be replaced if lost,
              stolen, or damaged, and is valid only for the event and seat
              indicated on the ticket. This ticket serves as a revocable license
              to attend the event listed on the front and is subject to the full
              terms available at www.ticketmaster.com. This license may be
              revoked without refund if the terms are not followed. Unauthorized
              sale or attempted sale is prohibited. Tickets purchased from
              unauthorized sources may be invalid, lost, stolen, or counterfeit,
              in which case they will be void. Maximum resale restrictions may
              apply. In New York, if the venue seats more than 5,000 people,
              tickets cannot be resold within 1,500 feet of the venue under
              penalty of law. If an event is canceled, the ticket may be
              exchanged for a seat of the same price for either (a) a
              rescheduled event, if applicable, or (b) any event designated by
              the venue within 12 months of the original event, if available.
              Please note that time, opponent, rosters, and date are subject to
              change. This ticket may not be used for advertising, promotion, or
              other commercial purposes without the written consent of the
              issuer. Applicable taxes are included. The ticket holder assumes
              all risks and dangers occurring before, during, or after the
              event, including injury of any kind, and risks associated with
              contracting a communicable disease or illness (including COVID-19,
              viruses, bacteria, or other pathogens). The ticket holder waives
              all claims against the venue, league participants, teams, artists,
              promoters, Ticketmaster, and their respective representatives,
              affiliates, and personnel.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
